import React from 'react';
import { Typography, Button, Avatar } from '@material-ui/core';
import PropTypes from 'prop-types';
import Dropzone from 'sharedComponents/Dropzone';
import useUploadFile from 'reducers/hooks/useUploadFile';
import { useTranslation } from 'react-i18next';

import { isBlank } from 'utils/helperMethods';
import Loader from 'sharedComponents/Loader';
import useStyles from './useStyles';

const CompanyLogo = props => {
  const { label, value, isSaving, onFinish } = props;
  const classes = useStyles();
  const { t } = useTranslation();
  const { uploadCompanyLogoToS3, uploadingCompanyLogoImage } = useUploadFile();

  const buildCachedImage = (fields, file) => {
    return {
      id: fields.key.match(/^cache\/(.+)/)[1],
      storage: 'cache',
      metadata: {
        size: file.size,
        filename: file.name,
        mimeType: file.type,
      },
    };
  };

  const handleOnDrop = async file => {
    const currentFile = file[0];
    const params = { type: currentFile.type, filename: currentFile.name };
    const cachedFileFields = await uploadCompanyLogoToS3(params, currentFile);
    const cachedVideo = buildCachedImage(cachedFileFields, currentFile);
    onFinish(cachedVideo);
  };

  const isLoading = isSaving || uploadingCompanyLogoImage;

  return (
    <div className={classes.container}>
      <Typography variant="body2" className={classes.label}>
        {label}
      </Typography>
      <div className={classes.content}>
        <div className={classes.logoContainer}>
          {isLoading ? (
            <Loader />
          ) : (
            <Avatar alt="company logo" src={value} className={classes.image} variant="square">
              {t('components.RealEstateAgentSettingsPage.ProfileForm.CompanyLogo.logo')}
            </Avatar>
          )}
        </div>
        <Dropzone handleOnDrop={handleOnDrop}>
          <Button variant="outlined" color="primary" className={classes.button}>
            {isBlank(value)
              ? t('components.RealEstateAgentSettingsPage.ProfileForm.CompanyLogo.uploadCompanyLogo')
              : t('components.RealEstateAgentSettingsPage.ProfileForm.CompanyLogo.changeCompanyLogo')}
          </Button>
        </Dropzone>
      </div>
    </div>
  );
};

CompanyLogo.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.string,
  isSaving: PropTypes.bool.isRequired,
  onFinish: PropTypes.func.isRequired,
};

CompanyLogo.defaultProps = {
  value: null,
};

export default CompanyLogo;



// WEBPACK FOOTER //
// ./src/components/RealEstateAgentSettingsPage/components/ProfileForm/components/CompanyLogo/CompanyLogo.js